import { render } from "./AddTacTemplate.vue?vue&type=template&id=241a416e"
import script from "./AddTacTemplate.vue?vue&type=script&lang=js"
export * from "./AddTacTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__